import { TranslateService } from '@ngx-translate/core';
import { getSpaceUrl } from 'src/app/common/utils/url';
import { Alert, PriorityConfig, SpaceAlertEntity } from '../../models/alert';
import { AlertViewModel } from './alert.view-model';

/** Base for the alert types scoped to a space (safeguarding, nudity). */
export abstract class SpaceAlertViewModel<
  TEntity extends SpaceAlertEntity,
> extends AlertViewModel<TEntity> {
  constructor(
    alert: Alert<TEntity>,
    protected readonly translateService: TranslateService,
    priorityConfig: PriorityConfig | null = null,
  ) {
    super(alert, priorityConfig);
  }

  /** Spaces are hard-deleted, so a deleted space's `spaceId` populates to null. */
  get isSpaceDeleted(): boolean {
    return !this.entity?.spaceId;
  }

  get spaceName(): string {
    return this.entity?.spaceId?.title ?? '';
  }

  get spaceUrl(): string {
    return getSpaceUrl(this.entity?.spaceId?._id ?? '');
  }

  override get relatedNotice(): string | null {
    return this.isSpaceDeleted
      ? this.translateService.instant('This Space has been deleted and is no longer accessible.')
      : null;
  }
}
